export default __webpack_public_path__ + "UI/assets/media/appstore_light-e40676c9.png";